export const OFFER_STATUS_TONE: Record<string, string> = {
  draft: 'bg-muted text-muted-foreground',
  sent: 'bg-amber-500/15 text-amber-700 dark:text-amber-400',
  requested: 'bg-sky-500/15 text-sky-700 dark:text-sky-400',
  rejected: 'bg-red-500/15 text-red-700 dark:text-red-400',
  accepted: 'bg-emerald-500/15 text-emerald-700 dark:text-emerald-400',
  declined: 'bg-red-500/15 text-red-700 dark:text-red-400',
  withdrawn: 'bg-muted text-muted-foreground',
};
